import { isFieldErrorResponse, useApiOrdersV1PurchaseOrdersUpdatePartialUpdate } from 'api';
import { useNotification } from 'features';
import { UseFormReturn } from 'form';

import { UploadDocumentProps } from '../../../document';
import { UpdateFormValues } from '../../pages/PurchaseOrderUpdate/PurchaseOrderUpdate';
import { redirectToPurchaseOrderPage } from '../../utils/redirectToPurchaseOrderPage';
import { useUploadAndCreatePurchaseOrderDocument } from '..';

export const useUpdatePurchaseOrder = (form: UseFormReturn<UpdateFormValues, unknown, UpdateFormValues>) => {
  const { setError, getValues } = form;
  const uploadAndCreateDocument = useUploadAndCreatePurchaseOrderDocument();
  const { open } = useNotification();

  return useApiOrdersV1PurchaseOrdersUpdatePartialUpdate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            setError(field as keyof UpdateFormValues, {
              message: error.response.data[field],
            });
          });
        }

        if (error.status === 403) {
          open({ message: 'You do not have authorization to perform this action', type: 'error' });
        }
      },
      async onSuccess(data) {
        const documents = getValues().documents;
        if (documents) {
          await Promise.all(
            documents?.map((document: UploadDocumentProps) => uploadAndCreateDocument(document, { slug: data.slug }))
          );
        }

        redirectToPurchaseOrderPage(data.slug);
      },
    },
  });
};
